<ds-modal
  [id]="exitFlowModalId"
  [closeOthers]="true"
  [maxWidth]="modalWidth"
  (onCloseModalEvent)="close()"
>
  <div>
    <h2 class="text-center neutral-600-text">
      <b class="block"> {{ isPartner ? 'Send to an advisor?' : 'Send to your agent?' }}</b>
    </h2>

    <div class="row pad-20">
      <div class="column twelve">
        <div class="flex items-center">
          <div>
            <p class="margin-0">
              We'll send what you've entered so far to
              {{ isPartner ? 'an advisor' : 'your agent' }} and they'll reach out to you for the
              rest. If you choose Exit, any info you've entered will be deleted.
            </p>
          </div>
        </div>
      </div>

      <div class="column twelve pad-top-20 flex items-center justifyButtons">
        <a
          dsContent
          [contentPath]="'shared.cancel'"
          class="caption margin-left-8 primary-800-text font-weight-bold"
          (click)="cancelModal.emit(); close()"
        ></a>
        <button
          class="margin-left-8 margin-right-8 -outline-white"
          ds-button
          aria-label="Exit"
          (click)="exit.emit(); close()"
        >
          Exit
        </button>
        <button ds-button aria-label="Send to my agent" (click)="notifyAgent.emit(); close()">
          {{ isPartner ? 'Send to an advisor' : 'Send to my agent' }}
        </button>
      </div>
    </div>
  </div>
</ds-modal>
